"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextInput = require("../TextInput");

var _Typography = require("../Typography");

var _helpers = require("../../utils/helpers");

var _SearchInput = require("./SearchInput.style");

var SearchInput = function SearchInput(_ref) {
  var chips = _ref.chips,
      value = _ref.value,
      label = _ref.label,
      chipsLabel = _ref.chipsLabel,
      onChangeCallback = _ref.onChangeCallback,
      rest = _objectWithoutProperties(_ref, ["chips", "value", "label", "chipsLabel", "onChangeCallback"]);

  var _react$default$useSta = _react.default.useState(null),
      _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
      selectedChip = _react$default$useSta2[0],
      setSelectedChip = _react$default$useSta2[1];

  var _react$default$useSta3 = _react.default.useState(false),
      _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
      isFocused = _react$default$useSta4[0],
      setIsFocused = _react$default$useSta4[1];

  var idRef = _react.default.useRef((0, _helpers.getUniqueID)());

  var inputRef = _react.default.useRef();

  var showChips = isFocused && !value;

  _react.default.useEffect(function () {
    if (value) {
      setSelectedChip(null);
    }
  }, [value]);

  var checkEvent = function checkEvent(event) {
    // If the user clicks outside the component we close it.
    if ((inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) && !inputRef.current.contains(event.target)) {
      setIsFocused(false);
    }
  };

  _react.default.useEffect(function () {
    document.body.addEventListener('mousedown', checkEvent, false);
    return function () {
      return document.body.removeEventListener('mousedown', checkEvent, false);
    };
  }, []);

  var handleChipClick = function handleChipClick(val, event) {
    event.stopPropagation();
    setIsFocused(false);
    setSelectedChip(val);
    onChangeCallback(val);
  };

  if (chips && chips.length > 0) {
    return /*#__PURE__*/_react.default.createElement("div", null, label && /*#__PURE__*/_react.default.createElement(_SearchInput.Label, {
      htmlFor: idRef.current
    }, label), /*#__PURE__*/_react.default.createElement(_SearchInput.SearchInputWrapper, {
      ref: inputRef
    }, /*#__PURE__*/_react.default.createElement(_SearchInput.InputWrapper, {
      isFocused: showChips
    }, /*#__PURE__*/_react.default.createElement(_SearchInput.Input, Object.assign({
      inputType: _TextInput.TextInputType.Text,
      value: selectedChip || value,
      onFocus: function onFocus() {
        return setIsFocused(true);
      },
      id: idRef.current,
      onChangeCallback: onChangeCallback,
      autoComplete: "off"
    }, rest))), showChips && /*#__PURE__*/_react.default.createElement(_SearchInput.Wrapper, null, /*#__PURE__*/_react.default.createElement(_SearchInput.Inner, null, /*#__PURE__*/_react.default.createElement(_Typography.Body, {
      size: "xsmall"
    }, chipsLabel), /*#__PURE__*/_react.default.createElement(_SearchInput.Chips, null, chips.map(function (chip) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: chip,
        role: "button",
        tabIndex: "0",
        onClick: function onClick(evt) {
          return handleChipClick(chip, evt);
        },
        onKeyDown: function onKeyDown(evt) {
          return handleChipClick(chip, evt);
        }
      }, /*#__PURE__*/_react.default.createElement(_SearchInput.Chip, null, chip));
    }))))));
  }

  return /*#__PURE__*/_react.default.createElement("div", null, label && /*#__PURE__*/_react.default.createElement(_SearchInput.Label, {
    htmlFor: idRef.current
  }, label), /*#__PURE__*/_react.default.createElement(_SearchInput.SearchInputWrapper, null, /*#__PURE__*/_react.default.createElement(_SearchInput.InputWrapper, {
    isFocused: showChips
  }, /*#__PURE__*/_react.default.createElement(_SearchInput.Input, Object.assign({
    inputType: _TextInput.TextInputType.Text,
    value: value,
    id: idRef.current,
    onChangeCallback: onChangeCallback,
    autoComplete: "off"
  }, rest)))));
};

SearchInput.propTypes = {
  chips: _propTypes.default.arrayOf(_propTypes.default.string),
  value: _propTypes.default.string.isRequired,
  label: _propTypes.default.string,
  chipsLabel: _propTypes.default.string,
  onChangeCallback: _propTypes.default.func.isRequired
};
SearchInput.defaultProps = {
  chips: null,
  label: 'Search',
  chipsLabel: 'Search suggestions:'
};
var _default = SearchInput;
exports.default = _default;